export const PRODUCT_LIST_READY = "product-list:ready";
export const PRODUCT_LIST_EMPTY = "product-list:empty";
export const PRODUCT_LIST_CARD_IN_VIEW = "product-list:card-in-view";
export const PRODUCT_LIST_CARD_CLICK = "product-list:card-click";
export const PRODUCT_LIST_QUICKVIEW_OPENED = "product-list:quick-view:opened";
export const PRODUCT_LIST_QUICKVIEW_UPDATED = "product-list:quick-view:updated";
export const PRODUCT_LIST_QUICKVIEW_ADD_TO_BASKET =
  "product-list:quick-view:add-to-basket";
export const PRODUCT_LIST_REMOVE_PRODUCT = "product-list:remove-product";
export const PRODUCT_LIST_INCREASE_QUANTITY = "product-list:increase-quantity";
export const PRODUCT_LIST_DECREASE_QUANTITY = "product-list:decrease-quantity";
export const PRODUCT_LIST_ADD_TO_WISHLIST = "product-list:add-to-wishlist";
export const PRODUCT_LIST_CTA_ADD_TO_BASKET = "product-list:cta:add-to-basket";
export const PRODUCT_LIST_CTA_EMAIL_ME = "product-list:cta:email-me";
export const PRODUCT_LIST_CTA_MORE_INFORMATION =
  "product-list:cta:more-information";
export const PRODUCT_LIST_CTA_VIEW_OPTIONS = "product-list:cta:view-options";
export const PRODUCT_LIST_CTA_IN_STORE_ONLY = "product-list:cta:in-store-only";
export const PRODUCT_LIST_CTA_OUT_OF_STOCK = "product-list:cta:out-of-stock";
export const PRODUCT_LIST_CTA_WELL_BE_IN_TOUCH =
  "product-list:cta:well-be-in-touch";
export const PRODUCT_LIST_CTA_GO_TO_BASKET = "product-list:cta:go-to-basket";
export const PRODUCT_LIST_CTA_VIEW_RANGE = "product-list:cta:view-range";
